import type { NoticeTone } from '@/components/primitives/AppNotice/notice-types'

/** One kind of workspace-wide state the shell banner can announce: when it holds, what it says, and the one action it offers. */
export interface ShellBannerSource {
  id: string
  visible: () => boolean
  tone: NoticeTone
  message: () => string
  actionLabel: () => string
  action: () => void
}

/** The banner sources in precedence order, first wins. */
export const SHELL_BANNER_SOURCES: readonly ShellBannerSource[] = []
